import React, { Component } from "react";


class Footer extends Component {

    render() {
        return (
            <footer className="footer">
                <div className="footer_container">

                    <div className="copyright">
                        <p>
                            Allen Lai. Built with{' '}
                            <i className="fa fa-heart fa-1" /> in Washington, D.C..
                        </p>
                    </div>

                </div>
            </footer>
        );
    }


}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/footer/Footer.jsx